import React, { useEffect, useState } from 'react';
import PackagesContainer from '../packages';
import attentionIcon from '../../../assets/icons/attention-triangle.svg';
import { useLocation } from 'react-router-dom';
import { useShipForm } from '../../../context/shipForms';
import { AddressDto, ReferenceRouteFormDto } from '../../../types';
import MainRatesPage from '../rates';
import MainInternationalPage from '../international';
import { mapAddLegPayloadForRatesQuote } from '../../../utils/helper';

interface Props {
  setShowPackages: any;
  setShowAttention: any;
  showPackages: boolean;
  setCurrentShipmentStatus: any;
  isQuote?: boolean;
}
function AttentionScreen({
  showPackages,
  setShowPackages,
  setShowAttention,
  setCurrentShipmentStatus,
  isQuote,
}: Props) {
  const {
    getDestinationFormData,
    getOriginFormData,
    getSelectedCarrierContext,
    getReferenceFormDataContext,
    getAddLegShipmentDataContext,
    getAddLegShipmentPackagesContext,
    setRatesApiPayloadContext,
    setSelectedRateContext,
  } = useShipForm();
  const location = useLocation();
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const originFormContextData: AddressDto = getOriginFormData();
  const selectedCarriersContext: any = getSelectedCarrierContext();
  const referenceFormContextData: ReferenceRouteFormDto =
    getReferenceFormDataContext();
  const addLegShipmentDataContext: any = getAddLegShipmentDataContext();
  const addLegShipmentPackagesContext: any = getAddLegShipmentPackagesContext();

  const [showratesForm, setShowRatesForm] = useState(false);
  const [showInternationScreenForm, setShowInternationScreenForm] =
    useState(false);
  const isAddLeg = location.pathname === '/app/add-leg';
  function nextRoute() {
    if (isAddLeg) {
      goToRatesScreen();
    } else {
      setShowPackages(true);
      window.scrollTo(0, 0);
      setCurrentShipmentStatus('packages');
    }
  }
  function payloadForAddLegShipment() {
    let payloadOfPackages = mapAddLegPayloadForRatesQuote(
      destinationFormContextData,
      originFormContextData,
      selectedCarriersContext,
      addLegShipmentPackagesContext,
      referenceFormContextData,
      addLegShipmentDataContext?.is_food
    );
    setRatesApiPayloadContext(payloadOfPackages);
  }

  function goToRatesScreen() {
    setCurrentShipmentStatus('rates');
    //go to internation screen
    const isOriginOutsideCanada = originFormContextData.country !== 'CA';
    const isDestinationOutsideCanada =
      destinationFormContextData.country !== 'CA';
    const isSameCountry =
      originFormContextData.country !== destinationFormContextData.country;
    const shouldApplyCondition =
      !isQuote &&
      isSameCountry &&
      (isOriginOutsideCanada || isDestinationOutsideCanada);
    if (shouldApplyCondition) {
      setShowInternationScreenForm(true);
    } else {
      setShowRatesForm(true);
    }
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    if (isAddLeg) {
      setSelectedRateContext(null);
      payloadForAddLegShipment();
    }
  }, []);
  return (
    <>
      {showratesForm ? (
        <MainRatesPage
          setShowRatesForm={setShowRatesForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : showInternationScreenForm ? (
        <MainInternationalPage
          setShowInternationScreenForm={setShowInternationScreenForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowRatesForm={setShowRatesForm}
        />
      ) : showPackages ? (
        <PackagesContainer
          isQuote={isQuote}
          setShowPackages={setShowPackages}
          setShowAttention={setShowAttention}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : (
        <div className='attention-screen-overlay'>
          <div className='modal-dialog modal-fullscreen'>
            <div
              className='modal-content'
              style={{ backgroundColor: '#F8F8F8' }}
            >
              <div className='modal-body'>
                <div className='d-flex align-items-center justify-content-center flex-column'>
                  {/* <i
                  className='bi bi-exclamation-octagon-fill red'
                  style={{ fontSize: '7em' }}
                ></i> */}
                  <img
                    src={attentionIcon}
                    className=''
                    alt=''
                    style={{
                      width: 100,
                      height: 100,
                      alignContent: 'center',
                      marginTop: 0,
                      marginBottom: 5,
                    }}
                  />
                  <h2 className='lex-24-500 color-danger mb_0'>Attention!</h2>
                  <h2 className='lex-24-500 color-danger'>
                    bbe is not accepting Dangerous Goods
                  </h2>
                </div>
                <div className='row px-4 mt-4'>
                  <div className='col-sm-12'>
                    <p className='fs-6'>
                      A list of common dangerous goods is below and may not
                      include all dangerous goods items. Confirm that your
                      shipment does not contain dangerous goods by accepting the
                      terms below. If you are not sure if the item you are
                      shipping is classified as a Dangerous Good, contact our{' '}
                      <a href='mailto:expediting@bbex.com'>
                        Freight Forwarding team
                      </a>{' '}
                      as you are accepting all responsibility for the shipment.
                    </p>
                  </div>
                </div>

                <div className='row px-4'>
                  <div className='col-sm-12 col-md-6'>
                    <h1 className='fs-6 fw-bold pb-2'>
                      Aircraft Spare Parts or Equipment
                    </h1>
                    <p className='fs-6'>
                      Explosives, chemical oxygen generators, unserviceable tire
                      assemblies, cylinders of oxygen, carbon dioxide, nitrogen
                      or fire extinguishers, paint, adhesives, aerosols,
                      life-saving appliances, first aid kits, fuel in equipment,
                      wet or lithium batteries, matches, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Automobiles/Vehicles, Parts
                    </h1>
                    <p className='fs-6'>
                      Engines, carburetors or fuel tanks which contain or have
                      contained fuel, wet batteries, compressed gases in tire
                      inflation devices, fire extinguishers, shocks/struts with
                      nitrogen, air bag inflators/air bag modules, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Blood, Diagnostic Specimens, Medical Supplies,
                      Pharmaceuticals
                    </h1>
                    <p className='fs-6'>
                      Infectious substances, dry ice, flammable liquids or
                      solids, oxidizers, organic peroxides, toxic or corrosive
                      substances, radioactive materials.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Camping Equipment</h1>
                    <p className='fs-6'>
                      Flammable gases (butane, propane, etc.), flammable liquids
                      (kerosene, gasoline, etc.), flammable solids (hexamine,
                      matches, etc.), etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Chemicals/Swimming Pool Products
                    </h1>
                    <p className='fs-6'>
                      Items meeting any of the criteria for dangerous goods,
                      particularly flammable liquids, flammable solids,
                      oxidizers, organic peroxides, toxic or corrosive
                      substances.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Comat</h1>
                    <p className='fs-6'>
                      Chemical oxygen generators in a passenger service unit
                      (PSU), various compressed gases such as oxygen, carbon
                      dioxide and nitrogen, gas lighters, aerosols, fire
                      extinguishers, flammable liquids such as fuels, paints and
                      adhesives, and corrosive material such as batteries. Other
                      items such as flares, first aid kits, life-saving
                      appliances. Matches, magnetized material, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Consolidated Consignments (Groupages)
                    </h1>
                    <p className='fs-6'>
                      Any of the defined classes of dangerous goods.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Dental Apparatus</h1>
                    <p className='fs-6'>
                      Flammable resins or solvents compressed or liquefied gas,
                      mercury and radioactive material.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Diving Equipment</h1>
                    <p className='fs-6'>
                      Cylinders (such as scuba tanks, vest bottles, etc.) of
                      compressed gas (air, oxygen, etc.), high intensity diving
                      lamps which can generate extreme high heat when operated
                      in air. In order to be carried safely, the bulb or battery
                      must be disconnected.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Drilling/Mining/Electrical Equipment
                    </h1>
                    <p className='fs-6'>
                      Explosive(s), magnetized materials or mercury and electron
                      tubes or wet batteries.
                    </p>
                  </div>
                  <div className='col-sm-12 col-md-6'>
                    <h1 className='fs-6 fw-bold pb-2'>
                      Electrically Powered Apparatus
                    </h1>
                    <p className='fs-6'>
                      (wheelchairs, lawn mowers, golf carts, etc.) may contain
                      wet batteries
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Film Crew, Media Equipment, Photographic Supplies
                    </h1>
                    <p className='fs-6'>
                      Explosive pyrotechnic devices, generators, wet batteries,
                      fuel, heat producing items, flammable liquids/solids,
                      oxidizers, organic peroxides, toxic or corrosive
                      substances, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Fuel Control Units</h1>
                    <p className='fs-6'>May contain flammable liquids.</p>

                    <h1 className='fs-6 fw-bold pb-2'>Household Goods</h1>
                    <p className='fs-6'>
                      Flammable liquids such as solvent based paint, adhesives,
                      polishes, aerosols (for passengers, those not permitted
                      under Subsection 2.3), bleach, corrosive oven or drain
                      cleaners, ammunition, matches, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Instruments</h1>
                    <p className='fs-6'>
                      May conceal barometers, manometers, mercury switches,
                      rectifier tubes, thermometers, etc. containing mercury.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Laboratory/Testing Equipment, Test Samples
                    </h1>
                    <p className='fs-6'>
                      Flammable liquids, flammable solids, oxidizers, organic
                      peroxides, toxic or corrosive substances.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>
                      Lithium Ion Battery/Batteries
                    </h1>
                    <p className='fs-6'>
                      Cell Phones, Wet Batteries, laptops, or Car Batteries..
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Machinery Parts</h1>
                    <p className='fs-6'>
                      Adhesives, paints, sealants, solvents, wet and lithium
                      batteries, mercury, cylinders of compress or liquefied
                      gas, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Repair Kits</h1>
                    <p className='fs-6'>
                      Organic peroxides and flammable adhesives, solvent based
                      paints, resins, etc.
                    </p>

                    <h1 className='fs-6 fw-bold pb-2'>Tool Boxes</h1>
                    <p className='fs-6'>
                      Explosives(power rivets), compressed gas or aerosols,
                      flammable gases(butane cylinders or torches), flammable
                      adhesives or paints, corrosive liquids, micro torches and
                      utility lighters (flammable gas), larger torches with a
                      self-igniting switch attached to a container or cylinder
                      of flammable gas, etc.
                    </p>
                  </div>
                </div>

                <p className='mt-4 px-1 fs-6'></p>

                <div className='row pt-2'>
                  <div className='col-sm-12 text-center align-content-center'>
                    <label className='lex-20-500'>
                      By clicking, you agree the shipment does not contain
                      Dangerous Goods.
                    </label>
                  </div>
                </div>
                <div className='row py-2'>
                  <div className='col-sm-12 text-center align-content-center'>
                    <button
                      type='button'
                      className='btn btn-ubbe-new-blue align-content-center mx-auto'
                      onClick={() => {
                        nextRoute();
                      }}
                    >
                      I Agree
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AttentionScreen;
